import React, { lazy } from "react";
import {
  Routes as Switch,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { getCookie } from "../Utils/Helper";

const Login = lazy(() => import("./Login"));

const Dashboard = lazy(() => import("./Dashboard"));
//Hotel Section Routes
const SingleHotelEdit = lazy(() => import("./Hotel/SingleHotelEdit"));
const BulkBasicInformation = lazy(() => import("./Hotel/BulkBasicInformation"));
const BulkDescription = lazy(() => import("./Hotel/BulkDescription"));
const BulkImages = lazy(() => import("./Hotel/BulkImages"));
const BulkReviews = lazy(() => import("./Hotel/BulkReviews"));
const BulkCreate = lazy(() => import("./Hotel/BulkCreate"));
const HotelSupplierCode = lazy(() => import("./Hotel/HotelSupplierCode"));

//Region Section Routes
const RegionCreate = lazy(() => import("./Region/RegionCreate"));
const SingleRegionEdit = lazy(() => import("./Region/SingleRegionEdit"));
const Landmark = lazy(() => import("./Region/Landmark"));
const RegionSupplierCode = lazy(() => import("./Region/RegionSupplierCode"));
const XMLService = lazy(() => import("./XMLService"));
const EWSReports = lazy(() => import("./EWSReports"));
const Error = lazy(() => import("./Error"));

export default function Routes(props) {
  return (
    <div className="RouteMainSection">
      <Switch>
        <Route
          path="/Login"
          exact
          element={
            <ProtectedRoutes>
              <Login isLoading={false} />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/Dashboard"
          exact
          element={
            <ProtectedRoutes>
              <Dashboard isLoading={false} />
            </ProtectedRoutes>
          }
        />

        {/* Hotel Section */}
        <Route
          path="/SingleHotelEdit"
          exact
          element={
            <ProtectedRoutes>
              <SingleHotelEdit />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/BulkBasicInformation"
          exact
          element={
            <ProtectedRoutes>
              <BulkBasicInformation />
            </ProtectedRoutes>
          }
        />
        <Route
          path="/BulkDescription"
          exact
          element={
            <ProtectedRoutes>
              {" "}
              <BulkDescription />{" "}
            </ProtectedRoutes>
          }
        />
        <Route
          path="/BulkImages"
          exact
          element={
            <ProtectedRoutes>
              {" "}
              <BulkImages />{" "}
            </ProtectedRoutes>
          }
        />
        <Route
          path="/BulkReviews"
          exact
          element={
            <ProtectedRoutes>
              {" "}
              <BulkReviews />{" "}
            </ProtectedRoutes>
          }
        />
        <Route
          path="/BulkCreate"
          exact
          element={
            <ProtectedRoutes>
              {" "}
              <BulkCreate />{" "}
            </ProtectedRoutes>
          }
        />
        <Route
          path="/HotelSupplierCode"
          exact
          element={
            <ProtectedRoutes>
              <HotelSupplierCode
                isSupplierHotel={true}
                component={"SupplierCodeHotel"}
                fileName={"Hotel_Supplier_Code_Upload.xlsx"}
              ></HotelSupplierCode>
            </ProtectedRoutes>
          }
        />
        {/* Region Section */}
        <Route
          path="/RegionCreate"
          exact
          element={
            <ProtectedRoutes>
              {" "}
              <RegionCreate />{" "}
            </ProtectedRoutes>
          }
        />
        <Route
          path="/SingleRegionEdit"
          exact
          element={
            <ProtectedRoutes>
              {" "}
              <SingleRegionEdit />{" "}
            </ProtectedRoutes>
          }
        />
        <Route
          path="/Landmark"
          exact
          element={
            <ProtectedRoutes>
              {" "}
              <Landmark />{" "}
            </ProtectedRoutes>
          }
        />
        <Route
          path="/RegionSupplierCode"
          exact
          element={
            <ProtectedRoutes>
              <RegionSupplierCode
                isSupplierHotel={false}
                component={"SupplierCodeRegion"}
                fileName={"Region_Supplier_Code_Upload.xlsx"}
              ></RegionSupplierCode>
            </ProtectedRoutes>
          }
        />
        <Route
          path="/EWSReports"
          exact
          element={
            <ProtectedRoutes>
              <EWSReports />
            </ProtectedRoutes>
          }
        />

        <Route path="/Error" exact element={<Error />} />
        <Route path="/" exact element={<Login />} />
        <Route path="/Login" exact element={<Login />} />
        <Route path="*" exact element={<Login />} />
        <Route path="/RXLImages/*" element={<XMLService path={props.url} />} />
      </Switch>
    </div>
  );
}

function ProtectedRoutes({ children }) {
  const location = useLocation();
  //Added Condition to redirect from wordpress domain to Qrate Domain (iframe)
  //Avoid this condition for Stay and TransferRedirect (iframe)
  if (
    window.top.location !== window.self.location &&
    window.self.location.pathname !== "/Stays" &&
    window.self.location.pathname !== "/TransferRedirect"
  ) {
    window.top.location = window.self.location;
  }

  let token = getCookie("access-token");
  if (token) return children;
  else if (location.pathname !== "/") return <Navigate to="/" replace />;
}
